import { app } from '../app.ts';
import { useApp } from '../hooks.ts';
import { CanvasView } from '../canvas/CanvasView.tsx';
import { Toolbar } from './Toolbar.tsx';
import { LayersPanel } from './LayersPanel.tsx';
import { PropertiesPanel } from './PropertiesPanel.tsx';
import { TopBar, ContextMenu, Toast, Home, ConnectDialog, Fps, Shortcuts } from './Chrome.tsx';
import { CommentsLayer } from './Comments.tsx';
import { Present } from './Present.tsx';
import { ShareDialog } from './Account.tsx';
import { VotingBar } from './Voting.tsx';
import { BranchBanner } from './Branches.tsx';
import { DevPanel } from './DevPanel.tsx';
import { AssistantPanel } from './AssistantPanel.tsx';
import { PluginsDialog } from './Plugins.tsx';
import { VersionHistory } from './Versions.tsx';
import { FindBar } from './FindBar.tsx';
import { Rulers } from './Rulers.tsx';
import { CursorChat, Timer, ScriptConsole } from './Extras.tsx';
import { TemplatesDialog } from './Templates.tsx';
import { QuickActions } from './QuickActions.tsx';
import { useApp as useAppHook } from '../hooks.ts';
import { FigmaTokenDialog } from './FigmaToken.tsx';

export function App() {
  const showLayers = useApp('ui', () => app.ui.showLayers);
  const showProps = useApp('ui', () => app.ui.showProps);
  const devMode = useApp('ui', () => app.ui.devMode);
  return (
    <div className="app">
      <TopBar />
      <div className="workspace">
        {showLayers && <LayersPanel />}
        <div style={{ position: 'relative', flex: 1, display: 'flex', minWidth: 0 }}>
          <CanvasView />
          <Rulers />
          <CommentsLayer />
          <FollowBanner />
          <FindBar />
          <CursorChat />
          <Timer />
          <VotingBar />
          <BranchBanner />
          <Toolbar />
          <AssistantPanel />
          <Toast />
          <Fps />
        </div>
        {showProps && (devMode ? <DevPanel /> : <PropertiesPanel />)}
      </div>
      <ContextMenu />
      <ConnectDialog />
      <ShareDialog />
      <PluginsDialog />
      <Home />
      <Present />
      <VersionHistory />
      <Shortcuts />
      <FigmaTokenDialog />
      <TemplatesDialog />
      <QuickActions />
      <ScriptConsole />
    </div>
  );
}

function FollowBanner() {
  const id = useAppHook(['ui', 'peers'], () => app.ui.followId);
  const p = id ? app.peers.get(id) : null;
  if (!p) return null;
  return (
    <div className="following-banner" style={{ boxShadow: `inset 0 0 0 3px ${p.color}` }}>
      <span style={{ position: 'absolute', top: 8, left: '50%', transform: 'translateX(-50%)', background: p.color, color: '#fff', padding: '4px 10px', borderRadius: 6, fontWeight: 600 }}>
        Following {p.name}
        {p.status ? ` · ${p.status}` : ''}
      </span>
    </div>
  );
}
